import {Component, OnDestroy, OnInit} from '@angular/core';
import {Page} from '../../core/services/HttpServiceBase';
import {CardQuery, CardService} from '../../services/card.service';
import {LanguageService} from '../../services/language.service';
import {ToastrService} from 'ngx-toastr';
import {Observable} from 'rxjs/Observable';
import {EditionService, EditiontQuery} from '../../services/edition.service';
import {Card, Edition, PriceRuleNotification, StockInventoryProduct} from '../../core/entities/entities';
import {CardConditionService} from '../../services/card-condition.service';
import * as Rx from 'rxjs/Rx';
import {Router} from '@angular/router';
import {TypeaheadMatch} from 'ngx-bootstrap';
import {ComponentBase} from '../../core/entities/component-base';
import {StockInventoryService} from '../../services/stock-inventory.service';

interface StockInventoryProductFilter {
  brandId?: any;
  categoryId?: any;
  templateIds?: number[];
  productIds?: number[];
  expansionIds?: number[];
  rarityIds?: number[];
  languageIds?: number[];
  minCardConditionId?: number;
  maxCardConditionId?: number;
  foil?: boolean;
  firstEdition?: boolean;
  holo?: number;
  total?: boolean;
  stockStatus?: string;
  bottomPriceRange?: number;
  topPriceRange?: number;
}

@Component({
  selector: 'app-stock-inventory',
  templateUrl: './stock-inventory.component.html',
  styleUrls: ['./stock-inventory.component.css']
})
export class StockInventoryComponent extends ComponentBase implements OnInit, OnDestroy {
  cardMeta: string[] = ['foil', 'firstEdition', 'total'];

  card_search: CardQuery = {
    autocomplete_edition: '',
    autocomplete_card_name: '',
    autocomplete_language: this.defaultLanguageId
  };
  cards: Observable<Card[]>;
  card: Card;

  columns = [
    {label: 'name', order: 'sip.product.enName'},
    {label: 'expansion', order: 'sip.product.expansion.enName'},
    {label: 'rarity', order: 'sip.product.rarity.description'}, // 'product.rarity'},
    {label: 'language', order: 'sid.language.name'},
    {label: 'minCondition', order: 'sid.minCondition.code'},
    {label: 'maxCondition', order: 'sid.maxCondition.code'},
    {label: 'nmEngPrice', order: 'sip.nmEngPrice'},
    {label: 'quantity', order: 'sip.quantity'},
    {label: 'stockStatus', order: 'sip.stockStatus'},
    {label: 'foil', order: 'temp.foil'},
    {label: 'firstEdition', order: 'temp.firstEdition'},
    {label: 'holo', order: 'temp.holo'},
    {label: 'total', order: 'sid.total'},
    {label: 'understockThreshold', order: 'sid.understockThreshold'},
    {label: 'overstockThreshold', order: 'sid.overstockThreshold'},
    {label: 'description', order: 'sid.template.description'}
  ];

  private _page: Page<StockInventoryProduct>;

  private fullEditions: Edition[] = [];
  editions: Edition[] = [];
  defaultFilters: StockInventoryProductFilter = {};

  filters: StockInventoryProductFilter = Object.assign({}, this.defaultFilters, this.getStorage('filters'));

  getName() {
    return 'StockInventoryComponent';
  }

  setOrder(field: string) {
    this._stockInventoryService.setOrder(this.page, field);
    this.setPageIndex(1);
  }

  getOrder(field: string) {
    return this._stockInventoryService.getOrder(this.page, field);
  }

  get page(): Page<StockInventoryProduct> {
    return this._page;
  }

  get pageIndex() {
    return this.page ? this.page.number + 1 : 1;
  }

  set pageIndex(num: number) {
    if (this.pageIndex == num) return;
    this.setPageIndex(num);
  }

  private setPageIndex(num: number) {
    this.spinnerService.show();
    this._stockInventoryService.toPage(this.page, num - 1).subscribe(ret => {
      this._page = ret;
      this.saveStorage('page', ret);
      this.spinnerService.hide();
    });
  }




  selectCard(event: TypeaheadMatch) {
    if (event && event.item) {
      this.card = event.item;
      this.card_search.autocomplete_card_name = this.card.name;
      this.card_search.autocomplete_edition = this.card.edition;
      this.filters.productIds = [this.card.id];
    }
  }

  eraseCard() {
    this.card_search.autocomplete_edition = '';
    this.filters.productIds = null;
    this.card = null;

    this.saveStorage('card', this.card);
  }
  get stockInventoryProducts(): Observable<StockInventoryProduct[]> {
    return this._stockInventoryService.dataChange;
  }


  get languages() {
    return this._languageService.dataChange;
  };

  get conditions() {
    return this._cardConditionService.dataChange;
  };






  constructor(private _stockInventoryService: StockInventoryService,
              private _languageService: LanguageService,
              private _cardConditionService: CardConditionService,
              private _cardService: CardService,
              private _editionServ: EditionService,
              private _router: Router,
              private _toastrService: ToastrService) {
    super();
  }

  clearFilters() {
    this.eraseCard();
    this.filters = Object.assign({}, this.defaultFilters);
    this.saveStorage('filters', this.filters);
    this.card_search.autocomplete_card_name = '';
  }

  prepareFilters(): StockInventoryProductFilter {
    const ret = Object.assign({}, this.filters);
    ['templateIds','productIds','expansionIds','rarityIds','languageIds'].forEach( k => {
      if(ret[k] != null){
        ret[k]=ret[k].filter( i => i != null);
      }
    });


    if (!this.isEnabledStructure('holo')) this.filters.holo = null;
    if (!this.isEnabledStructure('foil')) this.filters.foil = null;
    if (!this.isEnabledStructure('firstEdition')) this.filters.firstEdition = null;


    ret.brandId = this.brandId;
    ret.categoryId = this.categoryId;
    this.saveStorage('filters', ret);
    this.saveStorage('card', this.card);
    return ret;
  }

  applyFilters() {
    this._page = null;
    this._stockInventoryService.search(this.prepareFilters()).subscribe(ret => {
      this._page = ret;
      this.saveStorage('page', ret);
      this.spinnerService.hide();
    });
  }

  ngOnInit() {
    const me = this;
    this.spinnerService.show();

    this.cards = Rx.Observable.create((observer: any) => {
      observer.next(this.card_search);
    }).debounceTime(150)
      .distinctUntilChanged()
      .switchMap((term) => {
        return this._cardService.search({...term, categoryId: this.categoryId, brandId: this.brandId});
      });


    this._editionServ.getAllOrderByReleaseDateDesc().subscribe(ret => {
      me.fullEditions = ret;
      me.editions = me.fullEditions.filter( ed => ed.brandId == me.brandId);
    });

    this.filters = Object.assign({}, this.defaultFilters, this.getStorage('filters'));
    this.productStructureChange.subscribe( () => {
      me.prepareFilters();
      me.editions = me.fullEditions.filter( ed => ed.brandId == me.brandId);
    });

    let card = this.getStorage('card');
    if (card)
      this.selectCard(new TypeaheadMatch(Object.assign(new Card(), card)));



    let page = this.getStorage('page');
    if (page) {
      this._page = page;
      me.setPageIndex(me.pageIndex);
    } else {
      me.applyFilters();
    }
  }





  ngOnDestroy() {
  }
}



// WEBPACK FOOTER //
// ./src/app/conf/stock-inventory/stock-inventory.component.ts